import React, { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';

import { Toaster } from 'sonner';

export const ToasterComponent = () => {
  const portalContainerRef = useRef(null);
  if (portalContainerRef.current === null) {
    portalContainerRef.current = document.createElement('div');
  }

  useEffect(() => {
    const container = portalContainerRef.current;
    document.body.appendChild(container);

    return () => {
      document.body.removeChild(container);
    };
  }, []);

  return ReactDOM.createPortal(
    <Toaster
      position="top-right"
      closeButton={true}
      expand={true}
      visibleToasts={4}
      gap={8}
      toastOptions={{
        classNames: {
          error: 'bg-red-300 border-red-400',
          success: 'bg-green-300 border-green-400',
          info: 'bg-blue-300 border-blue-400',
          warning: 'bg-yellow-300 border-yellow-400',
          closeButton:
            '!w-6 !h-6 !bg-white !text-gray-700 !border !border-gray-300 !rounded-full !shadow-md hover:!bg-gray-100 hover:!text-gray-900',
        },
      }}
    />,
    portalContainerRef.current
  );
};
